import { ICON_VIEWBOX, ICONS, type IconName } from "./icons.generated";

export type { IconName };
export type IconWeight = 400 | 500;

export interface IconProps {
  name: IconName;
  /** Width and height in px. Default 24. */
  size?: number;
  /** 400 normally, 500 for emphasis: the active tab, icons on buttons and badges. */
  weight?: IconWeight;
  /** Says what the icon means when nothing else does. Without it the icon is decorative. */
  label?: string;
  className?: string;
}

/**
 * A Material Symbols Rounded icon (ADR 0023), drawn in the text colour. The PWAs and the mobile
 * kit use it; the console keeps lucide.
 */
export function Icon({ name, size = 24, weight = 400, label, className }: IconProps) {
  const shape = { className, width: size, height: size, viewBox: ICON_VIEWBOX, fill: "currentColor" };
  const path = <path d={ICONS[name][weight]} />;
  if (label) {
    return (
      <svg {...shape} role="img" aria-label={label} focusable="false">
        {path}
      </svg>
    );
  }
  return (
    <svg {...shape} aria-hidden="true" focusable="false">
      {path}
    </svg>
  );
}
